import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import { useParams } from 'react-router-dom'
import { getIdWithPrefix } from 'utils/pathUtils'
import { NewLodgingPage } from '../new-company-pages/NewLodgingPage'

export default function LodgingPage() {
  const urlParams = useParams()
  const { preferences } = usePreferences()
  const lodgingID = urlParams?.lodging_id
    ? getIdWithPrefix(
        urlParams?.lodging_id,
        preferences?.company_type_prefix_map[ContactCompanyType.Lodging]
      )
    : undefined

  return <NewLodgingPage lodgingID={lodgingID} />
}
